module.exports = __webpack_public_path__ + "assets/img/tracked-more.cb7120ec.svg";